module.exports = __webpack_public_path__ + "static/media/card-sponsor1-square.0fdcad3f.png";